import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';

import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import UserStore from '../../util/UserStore';
import $ from 'jquery';
import countries from '../../views/purchase/countries.json';
import Select from 'react-select';
import '../../prelogin/public/css/react-select.css';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import OrderReview from '../../views/purchase/OrderReview';
import HmEventRegistry from '../../model/HmEventRegistry';
import Moment from 'react-moment';
import 'moment-timezone';
import freeIcon from '../../images/icons/free.png';
import freeIconDisabled from '../../images/icons/free_disabled.png';
import StudentDropdown from './StudentDropdown';
import LoggedInPage from '../core/LoggedInPage';

var paymentErrorMap = {
	      "TXN_ERR_001": "Transaction not saved",
	      "TXN_ERR_002":"Transaction failed",
	      "TXN_ERR_003":"Field does not meet the minimum length",
	      "TXN_ERR_004":"Field exceeds the maximum length",
	      "TXN_ERR_005":"Space not allowed in the field",
	      "TXN_ERR_006":"Should be Alphanumeric Only",
	      "TXN_ERR_007":"Should contain Alphanumeric and permitted characters only",
	      "TXN_ERR_008":"Should contain Alphabets Only",
	      "TXN_ERR_009":"Should contain Numbers Only",
	      "TXN_ERR_010":"Should contain Numbers and dot (.)",
	      "TXN_ERR_011":"Contains Invalid Characters",
	      "TXN_ERR_012":"Should contain Alpabets and characters only",
	      "TXN_ERR_013":"Invalid parameter",
	      "TXN_ERR_014":"Invalid Transaction amount",
	      "TXN_ERR_015":"System Error"
	    };

/***
* Substitute locales instead of directly getting from RBUtil
**/
const PROD_LOCALE_GRP = {
	"IN_PLP":{
		"class1":"SPL",
		"class2":"SPL",
		"class3":"SPL",
		"class4":"SPL",
	}
}

const branchLocale = (categoryTxt, className) => {
	try{
		if(categoryTxt && className && PROD_LOCALE_GRP[categoryTxt]){
			return (PROD_LOCALE_GRP[categoryTxt][className.replace(/ /g, "").toLowerCase()]) ? PROD_LOCALE_GRP[categoryTxt][className.replace(/ /g, "").toLowerCase()] : categoryTxt;
		}
	}catch(e){
		console.error(e);
	}	
	return categoryTxt;
};

class MyProducts extends LoggedInPage {

	constructor(props) {
		super(props);
		
		this.state = {
				PLPloggedIn:false,
				prodLoaded:false,
				myProducts:{},
				firstchild:false,
				newStudentForm:false,
				newStudentSuccess:false,
				selectedStudentOption:{},
				selectedGradeOption:{},
				selectedProduct:null,
				selectedProductIndex:null,
				student_name:"",
				student_grade:"",
				student_board:null,
				student_username:"",
				student_password:"",
				student_confirmpassword:"",
				serverMessage:"",
				studentDpList:[],
				ModalShow:false,
				ModalContent:"",
				userRole:""
				
		}
		this.userId = null;
		this.purchaseObj = {};
		this.userObj = {};
		this.productsJson = {};
				
		this.userDataKey = "USER_SESSION";
		this.getProducts = this.getProducts.bind(this);
		//this.studentDropdownChange = this.studentDropdownChange.bind(this);
		//this.gradeDropdownChange = this.gradeDropdownChange.bind(this);
		//this.getNewStudentForm = this.getNewStudentForm.bind(this);
		//this.handleNewStudentSubmit = this.handleNewStudentSubmit.bind(this);
		//this.handleChange = this.handleChange.bind(this);
		//this.submitCreateStudent = this.submitCreateStudent.bind(this);
		//this.boardChange = this.boardChange.bind(this);
		//this.checkStudentAssigned = this.checkStudentAssigned.bind(this);
		//this.productClick = this.productClick.bind(this);
		//this.assignProduct = this.assignProduct.bind(this);
		//this.getGradeList = this.getGradeList.bind(this);
		//this.populateGradeDropdown = this.populateGradeDropdown.bind(this);		
		//this.removePasswords = this.removePasswords.bind(this);
		//this.hideStudentSuccessmsg = this.hideStudentSuccessmsg.bind(this);
		this.hideReviewModal = this.hideReviewModal.bind(this);
		this.getproductBox = this.getproductBox.bind(this);
		this.goToLanding = this.goToLanding.bind(this);
		this.isFreeProduct = this.isFreeProduct.bind(this);

		//this.studentDpList = [];
		this.gradeDpList = [];
		this.loginStoreKey="PLP_LOGIN_INFO";

		this.homeDropDownKey = "homeDropdown";
		this.gradeStore = null;
	}
	
	componentWillMount(){
		var me = this;
		var user_Success = function(userObj){
			if(typeof userObj === "object" && userObj.authToken){
				console.log("user::",userObj.userRole.role);
				me.setState({PLPloggedIn:true,userRole:userObj.userRole.role});
				me.userObj = userObj;
				me.getProducts();
			}else{
				me.setState({PLPloggedIn:false});
				HmEventRegistry.fireEvent("LOG_OUT_PROMPT");
			}			
		}

		var user_Failure = function(error){ console.log("session failure...",error);
			me.setState({PLPloggedIn:false});			
			if(typeof error === "object" && Object.keys(error).length > 0){
					if(typeof error.sessionValid !== "undefined" && error.sessionValid === "false"){
						HmEventRegistry.fireEvent("LOG_OUT_PROMPT");
					}
				}
		}
		this.sessionCheck(user_Success,user_Failure,true);
		
		
		try{
			 BrowserStorageUtil.removeItem(me.props.purchaseKey);
		}catch(e){
			if(console)
				console.error(e);
		}
	}
	componentDidMount(){	
		//this.getGradeList();	
		//this.loginTracking();		
	} 
	/*loginTracking(){
		try{
			var loginInfo = BrowserStorageUtil.getStoredSessionItem(this.loginStoreKey);
			//console.log("loginInfo:::",loginInfo);
			if(loginInfo){
				this.initiateTrack("login",JSON.parse(loginInfo));
				BrowserStorageUtil.removeSessionItem(this.loginStoreKey);
			}
		}catch(e){}
	}*/
	/*getGradeList(){
		var me = this;
		var callBackSuccess = function(response){
			if(response !== null){
				me.populateGradeDropdown(response);
			}

			console.log(" GET_GRADE_LIST response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in GET_GRADE_LIST");			
		}

		new HmAjax(this.getUrlFor("GET_GRADE_LIST")).get(callBackSuccess,callBackFailure);
	}*/
	/*populateGradeDropdown(data) {     	
		if(Object.keys(data).length>0){
			var classArr = data["IN"]
			for (var i = 0; i <= classArr.length; i++) {          
	          this.gradeDpList.push({"label":classArr[i],"value":classArr[i]});         
	        }
		}
       
        this.setState({selectedGradeOption:this.gradeDpList[0]});
    }*/
	/*gradeDropdownChange(selectedOption){
		var me = this;
    	this.setState({selectedGradeOption:selectedOption});    	 
	}*/
	populateStudentDropdown(myProducts) {
		//console.log("data=",this.state.myProducts);
		this.state.studentDpList = [];
		if(myProducts.related_children && Object.keys(myProducts.related_children).length > 0){
			this.state.studentDpList.push({"label":this.rb("product.selectedstudent"),"value":"select-student"});
			for(var key in myProducts.related_children){
				var username = myProducts.related_children[key].userName || myProducts.related_children[key].loginId;
				this.state.studentDpList.push({"label":username,"value":key});      
			}
			this.state.studentDpList.push({"label":this.rb("product.createstudent"),"value":"new-student"});
		}
        this.setState({selectedStudentOption:this.state.studentDpList[0]});
    }
	
	/*studentDropdownChange(selectedOption,index){
		var me = this;
		
		if(selectedOption.value == "select-student"){
			this.setState({selectedStudentOption:selectedOption});    	 
			return;
		}
		if(selectedOption.value == "new-student"){
			this.setState({student_name:"",student_grade:"",student_username:"",student_password:"",student_confirmpassword:"",serverMessage:""});
				
			this.setState({"ModalShow":true});
			setTimeout(function(){
				var board_cbse = document.getElementById('board_cbse');
				board_cbse.click();
			},200);
			return;
		}
    	this.setState({selectedStudentOption:selectedOption});    	 
    	
    	var msg = ("<div class='josefin'>Subscription to "+this.state.myProducts.product_details[this.state.selectedProduct.productId].ClassName+" "+this.state.myProducts.product_details[this.state.selectedProduct.productId].productDescription+" is for <span class='bluecolor'>"+selectedOption.label+"</span>. <br/ >The above subscription is only for the named student and cannot be changed later.</div>");
    	
    	 var buttons = [{
                label: me.rb("alert.ok"),
                handler: () => { me.assignProduct() }
            },
            {
                label: me.rb("alert.cancel"),
                handler: () => { }
            }]

        me.showAlert(" ", msg, buttons);
    	
	}*/
	getProducts(){
		
		//try {
				var me = this;

				var successHandler = function (data) {
					console.log("data :: ", data);
					//me.productData = data;
					//me.processData();
					me.populateStudentDropdown(data);
					
					me.setState({myProducts:data,prodLoaded:true});
					
					if(Object.keys(data).length>0){
						
						if(Object.keys(data.related_children).length == 1){
							var keys = Object.keys(data.related_children);
							if(data.related_children[keys[0]].password && data.related_children[keys[0]].password != null && data.related_children[keys[0]].password != ""){
								me.setState({firstchild:true});
							}
						}
						
						
						//me.removePasswords();
					}
				}

				var failureHandler = function (err) {
					var buttons = [{
						label: me.rb("go_home"),
						handler: () => { window.location.href = me.getUrlFor("LOGIN_HOME"); }
					}]
					me.showAlert(me.rb("error"), me.rb("generic_connect_error"), buttons);

					return;
				}

				var userId =  me.userObj.userId;				

				new HmAjax(this.getUrlFor("GET_PURCHASED_PRODUCTS")).get(successHandler,failureHandler);
			/*} catch (e) {
				var buttons = [{
					label: me.rb("go_home"),
					handler: () => {window.location.href = me.getUrlFor("LOGIN_HOME");}
				}]
				me.showAlert(me.rb("error"), me.rb("system_error"), buttons);
			}*/

	}
	  /*removePasswords(){
		   $.ajax({
            url: this.getUrlFor("REMOVE_PWD"),
            type: 'GET',
            xhrFields: {
		       withCredentials: true
		    },
		    crossDomain: true,
            success: function(response){
    			if(response !== null){
    				
    			}

    			console.log("response : ", response);
    		},
            error: function(response){
    			console.log("Error in REMOVE_PWD");
    		}
          });	   
	  }
	   */
	/*getNewStudentForm(){
		this.setState({newStudentForm:true,newStudentSuccess:false});
		
		setTimeout(function(){
			var board_cbse = document.getElementById('board_cbse');
			board_cbse.click();
		},200);
		
	}*/
	/*productClick(event){		
		this.setState({selectedProduct:this.state.myProducts.purchased_products_details[event.currentTarget.dataset.productindex], selectedProductIndex:event.currentTarget.dataset.productindex});
	}*/
	/*assignProduct(){
		if(this.state.selectedProduct == null){
				this.showAlert("","Please select a product.");
		}else{
			var me =this;			
			
			var formData = {
				  "productId":this.state.selectedProduct.productId,
				  "childId":this.state.selectedStudentOption.value,
				  "subscription_date":this.state.selectedProduct.subscriptionDate
			}
	
			
			var callBackSuccess = function(response){
				if(response !== null){
					console.log(response);
					console.log(response.response);
					console.log(response.response.toLowerCase());
					if(response.response.toLowerCase() == "success"){
						//me.state.myProducts.child_product_assign_details[me.state.selectedProduct.productId] = me.state.selectedStudentOption.value;
						me.state.myProducts.purchased_products_details[me.state.selectedProductIndex].childId = me.state.selectedStudentOption.value;
						me.setState(me.state);
						setTimeout(function(){
							me.setState({selectedProduct:null});
						},200);
						//me.showAlert("","Product Assigned Successfully.");
					}
				}
	
				console.log(" ASSIGN_PRODUCT response : ", response);
			}
	
			var callBackFailure = function(response){
				console.log("Error in ASSIGN_PRODUCT");			
			}
	
			new HmAjax(this.getUrlFor("ASSIGN_PRODUCT"),formData).post(callBackSuccess,callBackFailure);
		}
	}*/
	/*checkStudentAssigned(item){
		if(this.state.myProducts.purchased_products_details[item].childId){	
			return "assigned";
		}
		return "";
	}*/
	checkExpired(item){
		if(this.state.myProducts.purchased_products_details[item].expired){	
			return "expired";
		}
		return "";
	}

	isFreeProduct(prodid, tarrifid){
		try{
			return (this.state.myProducts.product_details[prodid].pricing_details[tarrifid].is_trial || this.state.myProducts.product_details[prodid].pricing_details[tarrifid].is_free_product);
		}catch(e){}
		return false;
	}

	isPaidAvailable(prodid, paidTariffId){
		try{
			return (this.state.myProducts.product_details[prodid].IS_PROD_AVAILABLE);
		}catch(e){}
		return false;
	}

	/*hideStudentSuccessmsg(){
		this.setState({newStudentForm:false,newStudentSuccess:false});
	}*/
	renderTitleMsg(){ 
	try{
		if(this.state.userRole == "PRNT"){
			return(
				<div>
					<div className="productAssignMsg col-8 offset-2 josefin row">
						<div className="col-2 alertleftdiv nopadding">
							<i className="material-icons alerticon">report_problem</i>
						</div>
						<div className="col-10">
							<div>The products you have purchased/done a free trial are now viewable in the respective student accounts.</div>
							<div>You can now view all your new purchases here in this account.</div>
						</div>					
					</div>
					<br />
					<br />
				</div>
			);
		}
		if(this.state.prodLoaded == true && this.state.firstchild == false){			
			if(Object.keys(this.state.myProducts).length>0){
				if(this.state.myProducts.product_details && Object.keys(this.state.myProducts.product_details).length > 0){
					var userName = "";
					for(var i=0;i<this.state.myProducts.purchased_products_details.length;i++){
						if(this.state.myProducts.related_children[this.state.myProducts.child_product_assign_details[this.state.myProducts.purchased_products_details[i].productId]]){
							userName = this.state.myProducts.related_children[this.state.myProducts.child_product_assign_details[this.state.myProducts.purchased_products_details[i].productId]].userName;							
							break;
						}
					}
					//var userName =  this.state.myProducts.related_children[this.state.myProducts.child_product_assign_details[this.state.myProducts.product_order[0]]].userName;
					/*return(
							<div className="productAssignMsg col-8 offset-2 josefin">
								Please assign newly purchased products to <b>{userName}</b> to use it. <br/>Click <span className="redfont">Assign To</span> and select <b>{userName}</b> to start using it.
							</div>
							);*/
				}
			}
		}

	}catch(e){
		console.error(e);
	}
		
	}
	goToLanding(event){		
		try{
			this.gradeStore = {
				"grd":event.currentTarget.dataset.classid,
				"prod":event.currentTarget.dataset.accessid
			}

			var goLanding = function(){
				//alert("goLanding");
				window.top.location.href = "/landing";
			}

			//console.log("classId ::  abdul",this.gradeStore)
			this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore), goLanding);
		}catch(e){}
		
	}

	pricetagFn(props){
		// var productType=props || "PLP";
		// return this.rb("banner."+productType);
	}

	classforcont(){
		if(this.isMobile() && !this.isTab()){
			return 'pInfo productcontent prodcontmob text-left';
		}else{
			return 'pInfo float-left productcontent text-left';
		}
	}

	getproductBox(item,index){
		var prodid = this.state.myProducts.purchased_products_details[item].productId;
		var tarrifid = this.state.myProducts.purchased_products_details[item].tariffId;
		//IMPORTANT: This is a very bad fix. Have to change it later
		var upgradeBtnAdded = false;


		if(this.state.myProducts.product_details[prodid].pricing_details[tarrifid].is_trial){
			for(var tarrif in this.state.myProducts.product_details[prodid].pricing_details){
				
			}
		}
		//console.log("tarrifid=="+tarrifid);
		if(this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId]){
			const prodCategory = this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId].productCategory || "";

			return(
			<div className={"productboxBig productbox clearfix "+this.checkExpired(item)} id={"product-"+item} key={index} data-productindex={index} >
				<div className="clearfix">
				<div className="prodCont">
					<div className="productimg">
					    {(()=>{
					    	if(prodCategory && window.prodImgNotAvail && window.prodImgNotAvail.includes(prodCategory)){
								//NOT Doing anything now
								return(
									<div className="noprodimgavail"> Product image not available
										</div>
								)
					    	}else{
					    		return(
					    			<div className="g-img">
									<img src={JSON.parse(this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId].productDetails)[0].thumbnail} alt=""/>
									</div>)
					    	}
					    })()}						
					</div>
					<div className={this.classforcont()}>
						<div className="g-text mb-0">
							{this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId].ClassName}
						</div>
						<div className="g-text">
							<p>{this.rb(branchLocale(this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId].productCategory,this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId].ClassName))}</p>
						</div>
									
						<div className="infoTxt row col-12 nopadding datecontainer">
							<div className="col-6 clearfix greyborderright">
								<div className=" smallgrey">{this.rb("product.purchasedon")}: </div>
								<div className="greyColor  datefield"><Moment unix format="DD/MM/YYYY">{this.state.myProducts.purchased_products_details[item].subscriptionDate}</Moment></div>												
							</div>	

							<div className="col-6 clearfix paddLeft">
								<div className=" smallgrey">{(this.state.myProducts.purchased_products_details[item].expired ? this.rb("product.expiredon"): this.rb("product.expired"))}: </div>
								<div className="greyColor  datefield"><Moment unix format="DD/MM/YYYY">{this.state.myProducts.purchased_products_details[item].expiryDate}</Moment></div>												
							</div>						
						</div>
						<div className="clearfix"></div>
						{/* <div className="infoTxt row col-12 nopadding datecontainer">							
							<div className="col-6 nopadding clearfix">
								<div className="inlineblock smallgrey">{(this.state.myProducts.purchased_products_details[item].expired ? this.rb("product.expiredon"): this.rb("product.expired"))}: </div>
								<div className="greyColor inlineblock datefield"><Moment unix format="DD/MM/YYYY">{this.state.myProducts.purchased_products_details[item].expiryDate}</Moment></div>												
							</div>
						</div> */}
						
						
						{/*	
						{(() => {
		    		       if(this.state.myProducts.purchased_products_details[item].childId){						    		    	   
		    		    	   var username = this.state.myProducts.related_children[this.state.myProducts.purchased_products_details[item].childId].userName || this.state.myProducts.related_children[this.state.myProducts.purchased_products_details[item].childId].loginId;
		    		    	   return(
		    		    			  <div>
		    		    			  	<div className="infoTxt">{this.rb("product.usedby")}: <span className="studisplay" title={username}>{username}</span></div>
		    		    			  </div>
		    		    	   );
		    		       }else{
		    		    	   if(this.state.myProducts.purchased_products_details[item].expired === false){
			    		    	   return(
			    		    			  <div>
			    		    			  		<StudentDropdown className="spdp" index={index} studentDpList={this.state.studentDpList} callBackParentStudentDdChange={this.studentDropdownChange} />					    		    			
					    		    	</div>
			    		    	   );
		    		    	   }
		    		       }
		    		    })()}
						*/}
					</div>
					</div>
					
					{(() => {
						try{
							var prodid = this.state.myProducts.purchased_products_details[item].productId;
							var tarrifid = this.state.myProducts.purchased_products_details[item].tariffId;
							if(this.state.myProducts.product_details[prodid].pricing_details[tarrifid].is_trial){
								if(this.state.myProducts.purchased_products_details[item].expired === false){
									return (
											<img className="freeIcon" src={freeIcon} alt=""/>
									);
								}else if(this.state.myProducts.purchased_products_details[item].expired === true){
									return (
											<img className="freeIcon" src={freeIconDisabled} alt=""/>
									);
								}
							}
						}catch(e){}
						
					})()}
					
					
					{(() => {
						try{
							var prodid = this.state.myProducts.purchased_products_details[item].productId;
							var paidTariffId = this.state.myProducts.product_details[prodid].paidTariffId;
							var category = this.state.myProducts.product_details[prodid].productCategory;

							//navigation to landing for loading current clicked lesson.
							var classId = this.state.myProducts.purchased_products_details[item].classId;
							var accessId = this.state.myProducts.purchased_products_details[item].accessId;

							//console.log("abdul "+classId+" "+accessId)
							if(this.state.myProducts.purchased_products_details[item].expired){
								if(this.state.myProducts.product_details[prodid].IS_PROD_AVAILABLE && paidTariffId){
									return (
										<div className="pInfo productcontent">
											<span className="expiredmsg"><i className="material-icons">mood_bad</i> {this.rb("product.expiredmsg")}</span>
											<span className={"r-btn productBuynow isExprdSub-Class" +classId} data-ga={"My Subscriptions - Class "+classId+" - Subscribe"} data-tarrifid={paidTariffId} data-productid={prodid} data-gradeid="" data-category={category} data-buyagain="true" onClick={this.props.showSubScripeLoginForm}>{this.rb("product.buynow")}</span>
											{/* <span className="inlineblock smallblack priceBuynow">{this.pricetagFn(this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId].productCategory)}</span> */}
										</div>
									);
								}else{
									return (
											<div className="pInfo productcontent">
												<span className="expiredmsg"><i className="material-icons">mood_bad</i> {this.rb("product.expiredmsg")}</span>												
											</div>
									);
								}
							}else if(this.isFreeProduct(prodid, tarrifid) && this.isPaidAvailable(prodid,paidTariffId)){
								upgradeBtnAdded = true;		
								return (
									<div className="pInfo productcontent">	
										 <span className={"r-btn productBuynow upgrapnkbtn isFreeSub-Class" +classId}  data-tarrifid={paidTariffId} data-productid={prodid} data-ga={"My Subscriptions - Class "+classId+" - Subscribe"} data-gradeid="" data-category={category} data-buyagain="true" onClick={this.props.showSubScripeLoginForm}>{this.rb("product.buynow")}</span>
											<span data-classid={classId}  data-accessid={accessId} className={"r-btn productBuynow isFreeStart-Class" +classId} data-ga={"My Subscriptions - Class "+classId+" - Start"} onClick={this.goToLanding}>{this.rb("home.start")}</span> 
									</div>
								);
							}else{
								return (
										<div className="pInfo productcontent">	
										<span data-classid={classId} data-accessid={accessId} className={"r-btn productBuynow isPurchStart-Class" +classId} data-ga={"My Subscriptions - Class "+classId+" - Start"} onClick={this.goToLanding}>{this.rb("home.start")}</span>
										</div>
									);
							}
						}catch(e){}
						
					})()}
					
					
					{(() => {
						if(this.state.myProducts.purchased_products_details[item].expired == false){	
							
							var classId = this.state.myProducts.purchased_products_details[item].classId;
							
							var secdiff = this.state.myProducts.purchased_products_details[item].expiryDate - this.state.myProducts.currentDateTime; 
							var mindiff = Math.floor( secdiff / 60 );
							secdiff = secdiff % 60;
							var hourdiff = Math.floor( mindiff / 60 );
							mindiff = mindiff % 60;
							var daydiff = Math.floor( hourdiff / 24 );
							hourdiff = hourdiff % 24;
							
							var daysLimit = 7;
							
							var prodid = this.state.myProducts.purchased_products_details[item].productId;
							var tarrifid = this.state.myProducts.purchased_products_details[item].tariffId;
							var paidTariffId = this.state.myProducts.product_details[prodid].paidTariffId;
							var category = this.state.myProducts.product_details[prodid].productCategory;
							if(this.state.myProducts.product_details[prodid].pricing_details[tarrifid].is_trial){
								daysLimit = 3;
							}
							
							if(daydiff < daysLimit)
							{
								if(daydiff == 0){
									if(this.state.myProducts.product_details[prodid].IS_PROD_AVAILABLE && this.state.myProducts.product_details[prodid].paidTariffId){
										return (
											<div className="pInfo productcontent">
												<span className="expiredmsg aboutexpire">
													<i className='material-icons'>alarm</i>&nbsp; 
													{this.rb("product.expireson")} <Moment unix format="DD/MM/YYYY">{this.state.myProducts.purchased_products_details[item].expiryDate}</Moment>
												</span>
												{(() => {
													if(!upgradeBtnAdded){
														return ( 
														<span className={"r-btn productBuynow isFreeSub-Class" +classId} data-ga={"My Subscriptions - Class "+classId+" - Subscribe"} data-tarrifid={paidTariffId} data-productid={prodid} data-gradeid="" data-category={category} data-buyagain="true" onClick={this.props.showSubScripeLoginForm}>{this.rb("product.buynow")}</span>
														 );
													}
												})}
												{/* <span className="inlineblock smallgrey priceBuynow">{this.pricetagFn(this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId].productCategory)}</span> */}
											</div>
										);
									}else{
										return (
											<span className="expiredmsg aboutexpire">
												<i className='material-icons'>alarm</i>&nbsp; 
												{this.rb("product.expireson")} <Moment unix format="DD/MM/YYYY">{this.state.myProducts.purchased_products_details[item].expiryDate}</Moment>
											</span>
										);
									}
									
									
								}
								else if(daydiff < 2){
									if(this.state.myProducts.product_details[prodid].IS_PROD_AVAILABLE && this.state.myProducts.product_details[prodid].paidTariffId){
										return (
											<div className="pInfo productcontent">
												<span className="expiredmsg aboutexpire">
													<i className='material-icons'>alarm</i>&nbsp; 
													{this.rb("product.expiresinday",[daydiff])}
												</span>
												{(() => {
													if(!upgradeBtnAdded){
														return (
														<span className={"r-btn productBuynow isFreeSub-Class" +classId} data-ga={"My Subscriptions - Class "+classId+" - Subscribe"} data-tarrifid={paidTariffId} data-productid={prodid} data-gradeid="" data-category={category} data-buyagain="true" onClick={this.props.showSubScripeLoginForm}>{this.rb("product.buynow")}</span>);
													}
												})}
												{/* <span className="inlineblock smallblack priceBuynow">{this.pricetagFn(this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId].productCategory)}</span> */}
											</div>
										);
									}else{
										return (
											<div className="pInfo productcontent">
												<span className="expiredmsg aboutexpire">
													<i className='material-icons'>alarm</i>&nbsp; 
													{this.rb("product.expiresinday",[daydiff])}
												</span>
											</div>
										);
									}
									
								}else{
									if(this.state.myProducts.product_details[prodid].IS_PROD_AVAILABLE && this.state.myProducts.product_details[prodid].paidTariffId){
										return (
											<div className="pInfo productcontent">
												<span className="expiredmsg aboutexpire">
													<i className='material-icons'>alarm</i>&nbsp; 
													{this.rb("product.expiresindays",[daydiff])}
												</span>
												{(() => {
													if(!upgradeBtnAdded){
														return (<span className={"r-btn productBuynow isFreeSub-Class" +classId} data-ga={"My Subscriptions - Class "+classId+" - Subscribe"} data-tarrifid={paidTariffId} data-productid={prodid} data-gradeid="" data-category={category} data-buyagain="true" onClick={this.props.showSubScripeLoginForm}>{this.rb("product.buynow")}</span>);
													}
												})}
												
												{/* <span className="inlineblock smallblack priceBuynow">{this.pricetagFn(this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId].productCategory)}</span> */}
											</div>
										);
									}else{
										return (
											<span className="expiredmsg aboutexpire">
												<i className='material-icons'>alarm</i>&nbsp; 
												{this.rb("product.expiresindays",[daydiff])}
											</span>
										);
									}
									
									
								}			
							}
	
						}
					})()}
				
				</div>
				
				{/*
				{(() => {
	    		       if(this.state.myProducts.purchased_products_details[item].childId){	
	    		    	   return(
	    		    			  <div>	    		    			  
	    		    			  	<div className="noteTxt">Note: To access this product, log in with student credentials sent to registered Email</div>
	    		    			  </div>
	    		    	   );
	    		       }else{
	    		    	   if(this.state.myProducts.purchased_products_details[item].expired === false){
		    		    	   return(
		    		    			  <div>				    		    			
				    		    			<div className="noteTxt">Note: Select/create a student account through the drop-down menu to start using this product</div>
				    		    	</div>
		    		    	   );
	    		    	   }else{
	    		    		    return(
		    		    			  <div>				    		    			
				    		    			<div className="noteTxt invisible">Note: Select/create a student account through the drop-down menu to start using this product</div>
				    		    	</div>
		    		    	   );
	    		    	   }
	    		       }
	    		    })()}
				*/}
				
			</div>
			)
		}
	}
	renderProducts(){
		try{
		var me = this;
		if(this.state.PLPloggedIn == false){
			return(
	    				<div> {this.showLoader()}</div>
	    		);
		}else if(this.state.prodLoaded == false){
			return(
	    				<div> {this.showLoader()}</div>
	    		);
		}else if(this.state.prodLoaded == true){			
			if(Object.keys(this.state.myProducts).length>0){
				if(this.state.myProducts.product_details && Object.keys(this.state.myProducts.product_details).length > 0){
					return(							
							Object.keys(this.state.myProducts.purchased_products_details).map((item,index) => (
									me.getproductBox(item,index)
							))			
					);
				}
			}else{
				return(					
					<div className="lineheight-40 josefin noproductsContainer">
						<div className="text-center">
							{ReactHtmlParser(this.rb("register.noproducts.msg"))}
						</div>
						<div className="text-center josefin">
							{ReactHtmlParser(this.rb("register.noproducts.msg2"))}
						</div>
						<div className="text-center josefin">
							{ReactHtmlParser(this.rb("register.noproducts.msg3"))}
						</div>
						{/*<div className="text-center josefin">
							OR
						</div>
						<div className="text-center">
							<a className="r-btn lineheight-20" href="/products">{this.rb("product.browseproducts")}</a>
						</div>*/}
					</div>
					
				);
			}
		}
	}catch(e){
		console.error(e);
	}
	}
	/*handleChange(e) {
		const target = e.currentTarget;	
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			submitButtonDisabled: !this.form.isValid()
		});
	}*/
	/*handleNewStudentSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) { 
			this.submitCreateStudent();
		}
	}*/
	/*boardChange(event){		
		this.setState({student_board:event.currentTarget.value,serverMessage:""});
	}*/
	/*submitCreateStudent(){
		
		if(this.state.student_board == null){
			this.setState({serverMessage:"Board is required."});
			return;
		}
		var formData = {
				"userName" : this.state.student_name,
				"loginId" : this.state.student_username,
				"grade" : this.state.selectedGradeOption.value,
				"board" : this.state.student_board,
				"countryCode":"IN",
				"userRole" : {
					"role" : "STU",
					"level": "1"
				},				
				"password" : this.state.student_password,
				"regnProvider" : "heymath"
		}

		var me =this;
		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status.toLowerCase() == "success"){		
					me.state.myProducts.related_children[response.createdUser.userId] = {loginId: response.createdUser.loginId, userName: response.createdUser.userName};		
					me.populateStudentDropdown(me.state.myProducts);
					var createdStudent = {"label":response.createdUser.userName, "value":response.createdUser.userId};
					me.state.selectedStudentOption = createdStudent
					me.setState({selectedStudentOption:createdStudent});
					me.assignProduct();
					//me.state.studentDpList.push({"label":response.createdUser.userName,"value":response.createdUser.userId});
					me.setState({ModalShow:false});
				}else{
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists."});
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"No such token."});
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured."});
					}else if(response.status == "empty_inputs"){
						me.setState({serverMessage:"OTP is required."});
					}else if(response.status == "token_not_verified"){
						me.setState({serverMessage:"OTP Verification is required."});
					}else if(response.status == "role_forbidden"){
						me.setState({serverMessage:"Parent user only can create student."});
					}					
					else{
						me.setState({serverMessage:response.status});
					}
				}
			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in CREATE_STUDENT");
			me.showAlert("","Error in CREATE_STUDENT");
		}

		new HmAjax(this.getUrlFor("CREATE_STUDENT"),formData).post(callBackSuccess,callBackFailure);
	}*/
	renderErrorMsg(){
		return this.state.serverMessage;
	}
	hideReviewModal(){
		this.setState({"ModalShow":false});
	}
	/*getStudentForm(thisRef){
		var me = this;
		return(
					<div  className="col-12 col-md-8 mx-auto text-center  mt-20 josefin">
						
						<FormWithConstraints ref={formWithConstraints => me.form = formWithConstraints}
						onSubmit={me.handleNewStudentSubmit} noValidate>
							<FormGroup for="student_name">		
								<FormControlInput type="text" className="student_name" name="student_name" placeholder={me.rb("billing.fullname")}
									onChange={me.handleChange}
								required minLength={1} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>
									<FieldFeedbacks for="student_name">
										<FieldFeedback when="valueMissing">{me.rb("billing.namerequired")}</FieldFeedback>
										<FieldFeedback when="*" />
									</FieldFeedbacks>
							</FormGroup>
							
							
							<Select		
						        onChange={me.gradeDropdownChange}
						        options={me.gradeDpList}
							 	onBlurResetsInput={false}
								onSelectResetsInput={false}		
							 	clearable={false}
							 	rtl={false}
							 	searchable={false}	
						      />
							
							
							<form className="form-inline mt-30">
								 <label className="form-check-label" for="board_icse">Board:</label>
								<div className="form-check">
							        <input className="form-check-input" name="radio_board" type="radio" id="board_cbse" value="CBSE" onChange={me.boardChange}/>
							        <label className="form-check-label" for="board_cbse">CBSE</label>
							    </div>
							
							    <div className="form-check">
							        <input className="form-check-input" name="radio_board" type="radio" id="board_icse" value="ICSE" onChange={me.boardChange}/>
							        <label className="form-check-label" for="board_icse">ICSE</label>
							    </div>
							    
							    <div className="form-check">
							        <input className="form-check-input" name="radio_board" type="radio" id="board_others" value="others" onChange={me.boardChange}/>
							        <label className="form-check-label" for="board_others">Others</label>
							    </div>
							 </form> 
							 
							<FormGroup for="student_username">		
								<FormControlInput type="text" className="student_username" name="student_username" placeholder={me.rb("login.userid")}
									onChange={me.handleChange}
								required minLength={6} maxLength={254} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="2"/>
									<FieldFeedbacks for="student_username">
										<FieldFeedback when="valueMissing">{me.rb("login.useridrequired")}</FieldFeedback>
										<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.userid.minimum",[6])}</FieldFeedback>
										<FieldFeedback when="*" />
									</FieldFeedbacks>
							</FormGroup>
							
							<FormGroup for="student_password">
								<FormControlInput type="password" className="student_password" name="student_password" placeholder={me.rb("rpwd.newpwd")}
									innerRef={password => me.password = password}
								onChange={me.handleChange}				
								required minLength={6} maxLength={50} tabIndex="3"/>
								
								<FieldFeedbacks for="student_password">
									<FieldFeedback when="valueMissing">{me.rb("login.pwdrequired")}</FieldFeedback>		
									<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
								</FieldFeedbacks>					
							</FormGroup>
							
							<FormGroup for="student_confirmpassword">
								<FormControlInput type="password" className="student_confirmpassword" name="student_confirmpassword" placeholder={me.rb("rpwd.confirmpwd")}
									innerRef={confirmpassword => me.confirmpassword = confirmpassword}
								onChange={me.handleChange}				
								required minLength={6} maxLength={50} tabIndex="4"/>
								
								<FieldFeedbacks for="student_confirmpassword">
									<FieldFeedback when="valueMissing">{me.rb("rpwd.confirmpwdrequired")}</FieldFeedback>
									<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
									<FieldFeedback when={value => value !== me.password.value}>{me.rb("rpwd.doesnotmatch")}</FieldFeedback>
								</FieldFeedbacks>					
							</FormGroup>						
							
							 
							
							<div className="server-messages">{me.renderErrorMsg()}</div>
						
							<div className="text-center"><button disabled={me.state.submitButtonDisabled} className="submitButton">{me.rb("button.assign")}</button></div>
							<br />
							<br />
						</FormWithConstraints>	
					</div>
				);
	}*/
	/*renderStudentInfo(){
		
		if(this.state.prodLoaded == true && Object.keys(this.state.myProducts).length>0){
			if(this.state.firstchild == true){
				var keys = Object.keys(this.state.myProducts.related_children);				
				var username = this.state.myProducts.related_children[keys[0]].loginId;
				var password = this.state.myProducts.related_children[keys[0]].password;
				
				var prodid = this.state.myProducts.purchased_products_details[0].productId;
				var tarrifid = this.state.myProducts.purchased_products_details[0].tariffId;
				
				var purchasesuccessmsg = "";
				if(this.state.myProducts.product_details[prodid].pricing_details[tarrifid].is_trial == false){
					purchasesuccessmsg = ReactHtmlParser("<div>"+this.rb('student.purchasesuccess')+"</div><br />");
				}
					
				return(					
					<div className="col-12 text-center mt-20">
						{purchasesuccessmsg}
						<div>{ReactHtmlParser(this.rb("student.studentcredential"))}</div>
						<br />
						<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{this.rb("login.userid")}: {username}</div>						
						<div>{this.rb("login.password")}: {password}</div>
						<br />						
					</div>
					
				);
			}
		}
	}*/
	/*renderProductsHeaderMsg(){
		if(this.state.prodLoaded == true){			
			if(Object.keys(this.state.myProducts).length>0){
				return (<span className="myproductsheadermsg josefin">To accecategoryr subscriptions, log out from the parent account and sign in with the student User ID and​ ​Password that was sent to your registered Email</span>);
			}
		}
	}*/
	render() {
		return (
				<div>
					{/*<section className="sectionTop">
						<div className="container">
							<div>
								<h3>Product details <span></span></h3>
							</div>
							<div className="productsContainer mt-20">								
								{this.renderProducts()}
							</div>
						</div>
					</section>*/}
					<section className="bg-grn productsbggrn">
						<div className="container">
							<h3>{this.rb("product.mysubscriptions")}</h3>
							{/*this.renderProductsHeaderMsg()*/}
						</div>
					</section>
					<div className="col-12 text-center">
					{this.renderTitleMsg()}	
					{this.renderProducts()}
					</div>
					{/*<div className="container row studentInfo">
						{this.renderStudentInfo()}
					</div>*/}
					
					<div>							
						<TestTakingModalComponent visible={this.state.ModalShow} dialogClassName="modal-lg">
							<div className="loginHeader text-center">	
								<div className="text-center modallogo loginHeaderTxt josefin">
									{this.rb("student.info")}
								</div>
								<div className="close loginClose" onClick={this.hideReviewModal}  aria-label="Close">
						          <span aria-hidden="true"><i className="material-icons">close</i></span>
						        </div>
							</div>
							<div className="modal-body">
								<div  className="col-12 col-md-8 mx-auto text-center  mt-20 josefin">
						
						<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
						onSubmit={this.handleNewStudentSubmit} noValidate>
							<FormGroup for="student_name">		
								<FormControlInput type="text" className="student_name" name="student_name" placeholder={this.rb("billing.fullname")}
									value={this.state.student_name} onChange={this.handleChange}
								required minLength={1} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>
									<FieldFeedbacks for="student_name">
										<FieldFeedback when="valueMissing">{this.rb("billing.namerequired")}</FieldFeedback>
										<FieldFeedback when="*" />
									</FieldFeedbacks>
							</FormGroup>
							
							
							<Select		
								value={this.state.selectedGradeOption}
						        onChange={this.gradeDropdownChange}
						        options={this.gradeDpList}
							 	onBlurResetsInput={false}
								onSelectResetsInput={false}		
							 	clearable={false}
							 	rtl={false}
							 	searchable={false}	
						      />
							
							
							<form className="form-inline mt-30">
								 <label className="form-check-label" for="board_icse">Board:</label>
								<div className="form-check">
							        <input className="form-check-input" name="radio_board" type="radio" id="board_cbse" value="CBSE" onChange={this.boardChange}/>
							        <label className="form-check-label" for="board_cbse">CBSE</label>
							    </div>
							
							    <div className="form-check">
							        <input className="form-check-input" name="radio_board" type="radio" id="board_icse" value="ICSE" onChange={this.boardChange}/>
							        <label className="form-check-label" for="board_icse">ICSE</label>
							    </div>
							    
							    <div className="form-check">
							        <input className="form-check-input" name="radio_board" type="radio" id="board_others" value="others" onChange={this.boardChange}/>
							        <label className="form-check-label" for="board_others">Others</label>
							    </div>
							 </form> 
							 
							<FormGroup for="student_username">		
								<FormControlInput type="text" className="student_username" name="student_username" placeholder={this.rb("login.userid")}
									value={this.state.student_username} onChange={this.handleChange}
								required minLength={6} maxLength={254} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>
									<FieldFeedbacks for="student_username">
										<FieldFeedback when="valueMissing">{this.rb("login.useridrequired")}</FieldFeedback>
										<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.userid.minimum",[6])}</FieldFeedback>
										<FieldFeedback when="*" />
									</FieldFeedbacks>
							</FormGroup>
							
							<FormGroup for="student_password">
								<FormControlInput type="password" className="student_password" name="student_password" placeholder={this.rb("rpwd.newpwd")}
									innerRef={password => this.password = password}
								value={this.state.student_password} onChange={this.handleChange}				
								required minLength={6} maxLength={50} tabIndex="1"/>
								
								<FieldFeedbacks for="student_password">
									<FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>	
									<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
								</FieldFeedbacks>					
							</FormGroup>
							
							<FormGroup for="student_confirmpassword">
								<FormControlInput type="password" className="student_confirmpassword" name="student_confirmpassword" placeholder={this.rb("rpwd.confirmpwd")}
									innerRef={confirmpassword => this.confirmpassword = confirmpassword}
								value={this.state.student_confirmpassword} onChange={this.handleChange}				
								required minLength={6} maxLength={50} tabIndex="1"/>
								
								<FieldFeedbacks for="student_confirmpassword">
									<FieldFeedback when="valueMissing">{this.rb("rpwd.confirmpwdrequired")}</FieldFeedback>		
									<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
									<FieldFeedback when={value => value !== this.password.value}>{this.rb("rpwd.doesnotmatch")}</FieldFeedback>
								</FieldFeedbacks>					
							</FormGroup>						
							
							 
							
							<div className="server-messages">{this.renderErrorMsg()}</div>
						
							<div className="text-center"><button disabled={this.state.submitButtonDisabled} className="submitButton">{this.rb("button.assign")}</button></div>
							<br />
							<br />
						</FormWithConstraints>	
					</div>
							</div>							
						</TestTakingModalComponent>
					</div>
						
						
				</div>
		);
	}
}

export default MyProducts;


// WEBPACK FOOTER //
// ./src/views/purchase/MyProducts.js